import React from "react";
import PropTypes from "prop-types";
import styles from "./ErrorItem.module.css";

import formatDate from "shared/@utils/formatDate";

/**
 *
 * Displays information about an error item.
 */

export function ErrorItem({
  error
}) {
  return (
    <div className={styles.container}>
      <div className={styles.item}>{error._id}</div>
      <div className={styles.item}>{`${formatDate(error.timestamp, "MM/DD/YYYY hh:mm A")}`}</div>
      <div className={styles.item}>{error.description}</div>
    </div>
  );
}

ErrorItem.propTypes = {
  /**
   * Object with the error info
   */
  error: PropTypes.objectOf(
    PropTypes.shape({
      _id: PropTypes.string,
      timestamp: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};
